module.exports = __webpack_public_path__ + "static/img/detail_hawthorne_02.34009a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/hawthorne-banner-campaign/detail_hawthorne_02.jpg
// module id = 246
// module chunks = 2